import { forwardRef, TextareaHTMLAttributes, ReactNode } from "react";
import { createBemBlockBuilder } from "@ebsco-ui/utils";
import TextControl from "@ebsco-ui/text-control";

import "./text-area.scss";

export interface TextAreaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string | ReactNode;
  id: string;
  className?: string;
  error?: string;
  disabled?: boolean;
}

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      id,
      className: consumerBlockClassName,
      label,
      error,
      disabled,
      ...rest
    }: TextAreaProps,
    ref,
  ) => {
    const getBemBlocksWith = createBemBlockBuilder([
      "eb-text-area",
      consumerBlockClassName,
    ]);

    return (
      <TextControl className={getBemBlocksWith()} label={label} error={error}>
        <textarea
          id={id}
          disabled={disabled}
          className={getBemBlocksWith("__textarea")}
          ref={ref}
          {...rest}
        />
      </TextControl>
    );
  },
);

TextArea.displayName = "TextArea";

export default TextArea;
